import React from 'react';
import { Label } from '../atoms/label';
export const ErrorMassage = (props) => {
    console.log(props.data)
    return (
        <div style={props.style}>
            <Label label={props.label} style={styles.errorMassage} />
            {/* 配列がpropsで渡されたらそこからエラーメッセージを表示する */}
            {props.data == undefined ? null : props.data.map((value, index) =>
                <div key={index} style={styles.errorMassageList}>{value}</div>
            )}
        </div>
    );
}
const styles = {
    errorMassage: {
        color: "red",
        fontSize: 12.8,
        letterSpacing: 2,
        paddingBottom: 8,
    },
    errorMassageList: {
        color: "red",
        fontSize: 12.8,
        letterSpacing: 2,
        paddingBottom: 2,
    },
}